import React from 'react';
import SMCLabel from '../../../components/Simple/SMCLabel';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import {SMCCheckbox} from '../../../components/Simple/SMCCheckbox';
import {useTranslation} from 'react-i18next';
import SMCButton from '../../../components/Simple/SMCButton';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Indentation from '../../../components/Simple/Indentation';
import {SMCRadioGroup, SMCRadio} from '../../../components/Simple/SMCRadio';
import {ServiceDomainsToExportTypeValues} from '.';
import RowLayout from '../../../components/Layouts/RowLayout';
import {SMCSelect, SMCOption} from '../../../components/Simple/SMCSelect';

function ExportSMPStepTwo({
    onCancel,
    onNext,
    onBack,
    pageParams
}) {
    const { t } = useTranslation();

    const {
        availableDomains,
        serviceDomainsToExportType, setServiceDomainsToExportType,
        serviceDomainToExport, setServiceDomainToExport,
        isExportUsers, setIsExportUsers,
        isExportGateways, setIsExportGateways,
        isExportPlans, setIsExportPlans,
        isExportItems, setIsExportItems,
        isExportSettings, setIsExportSettings,
    } = pageParams;

    return (
        <>
        <SMCModalBody lineHeight="24px">
            <SMCLabel bold fontSize="15px">{t('SMC_SYSOPS_EXPWIZ_HEAD2')}</SMCLabel>
            <SMCLabel>{t('SMC_SYSOPS_EXPWIZ_PORTAL_TEXT')}</SMCLabel>
            <Indentation>
                <SMCRadioGroup
                    value={serviceDomainsToExportType}
                    onChange={e => setServiceDomainsToExportType(e.target.value)}
                    style={{ lineHeight: '24px' }}
                >
                    <SMCRadio
                        value={ServiceDomainsToExportTypeValues.none}
                        label={t('SMC_SYSOPS_EXPWIZ_NONE')}
                    />
                    <SMCRadio
                        value={ServiceDomainsToExportTypeValues.all}
                        label={t('SMC_SYSOPS_EXPWIZ_ALLPORTALS')}
                    />
                    <RowLayout spacing="4px">
                        <SMCRadio
                            value={ServiceDomainsToExportTypeValues.specific}
                            label={t('SMC_SYSOPS_EXPWIZ_PORTAL_SELECT')}
                        />
                        <SMCSelect
                            value={serviceDomainToExport}
                            onChange={e => setServiceDomainToExport(e.target.value)}
                            disabled={serviceDomainsToExportType !== ServiceDomainsToExportTypeValues.specific}
                        >
                            { availableDomains && availableDomains.map(domainName => <SMCOption value={domainName} key={domainName}>{domainName}</SMCOption>) }
                        </SMCSelect>
                    </RowLayout>
                </SMCRadioGroup>
            </Indentation>
            <SMCLabel>{t('SMC_SYSOPS_EXPWIZ_DATA_TEXT')}</SMCLabel>
            <Indentation>
                <SMCCheckbox
                    checked={isExportUsers}
                    onChange={e => setIsExportUsers(e.target.checked)}
                    label={t('SMC_SYSOPS_EXPWIZ_USERS')}
                />
                <SMCCheckbox
                    checked={isExportGateways}
                    onChange={e => setIsExportGateways(e.target.checked)}
                    label={t('SMC_SYSOPS_EXPWIZ_GWS')}
                />
                <SMCCheckbox
                    checked={isExportPlans}
                    onChange={e => setIsExportPlans(e.target.checked)}
                    label={t('SMC_SYSOPS_EXPWIZ_PLANS')}
                />
                <SMCCheckbox
                    checked={isExportItems}
                    onChange={e => setIsExportItems(e.target.checked)}
                    label={t('SMC_SYSOPS_EXPWIZ_ITEMS')}
                />
                <SMCCheckbox
                    checked={isExportSettings}
                    onChange={e => setIsExportSettings(e.target.checked)}
                    label={t('SMC_SYSOPS_EXPWIZ_SETTINGS')}
                />
            </Indentation>
        </SMCModalBody>
        <SMCModalButtonContainer>
            <SMCButton onClick={onBack}>
                <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="arrow-circle-left" />
                {t('SMC_GEN_BACK')}
            </SMCButton>
            <SMCButton onClick={onNext}>
                {t('SMC_GEN_WIZNEXT')}
                <FontAwesomeIcon style={{ marginTop: '3px', marginLeft: '5px' }} color="grey" icon="arrow-circle-right" />
            </SMCButton>
            <SMCButton onClick={onCancel}>
                <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                {t('SMC_GEN_CANCEL')}
            </SMCButton>
        </SMCModalButtonContainer>
        </>
    )
}

export default ExportSMPStepTwo;